import { Checkbox } from '@material-ui/core';
import React, { useEffect, useState } from 'react';

import { Checkboxes } from '~/src/dash/components/Checkboxes';
import {
  borderRadius,
  Col,
  Cols,
  Row,
  Rows,
  spacingV2,
  Text,
  TextButton,
} from '~/src/dash/publicaUI';
import { IListItem } from '~/src/dash/types/menuList';
import { publicaColors } from '~/src/dash/utils/colors';

interface ICollapsibleCheckboxesProps {
  list: IListItem[];
  title: string;
  onChange: (id: string) => void;
  onSectionChange: (ids: string[], selected: boolean) => void; // to select/unselect the whole column
  isDisabled?: boolean;

  // both isExpandAll props are needed to implement an isExpandAll button
  isExpandAll: boolean;
  setIsExpandAll: (expanded: boolean) => void;

  // both isCollapseAll props are needed to implement a isCollapseAll button
  isCollapseAll: boolean;
  setIsCollapseAll: (collapsed: boolean) => void;
}

type ExpandCollapseSetStateFunc = (bool: boolean) => void;
export const handleClickExpandAll = (
  setIsExpandAllFunc: ExpandCollapseSetStateFunc,
  setIsCollapseAllFunc: ExpandCollapseSetStateFunc,
) => {
  setIsExpandAllFunc(true);
  setIsCollapseAllFunc(false);
};

export enum EDisplayExpandOrCollapseAll {
  Expand = 0,
  Collapse = 1,
}

export const handleClickCollapseAll = (
  setIsExpandAllFunc: ExpandCollapseSetStateFunc,
  setIsCollapseAllFunc: ExpandCollapseSetStateFunc,
) => {
  setIsExpandAllFunc(false);
  setIsCollapseAllFunc(true);
};

export const CollapsibleCheckboxes = ({
  title,
  list,
  onChange,
  onSectionChange,
  isDisabled,
  isExpandAll,
  setIsExpandAll,
  isCollapseAll,
  setIsCollapseAll,
}: ICollapsibleCheckboxesProps) => {
  const [isExpanded, setIsExpanded] = useState(isExpandAll);
  const [isSelected, setIsSelected] = useState<boolean>(false);

  useEffect(() => {
    if (isExpandAll) {
      setIsExpanded(true);
    }
  }, [isExpandAll]);

  useEffect(() => {
    if (isCollapseAll) {
      setIsExpanded(false);
    }
  }, [isCollapseAll]);

  const numberOfSelectedMetrics = list.filter((item) => item.selected).length;
  const length = list.length;
  const isAllSelected = length === numberOfSelectedMetrics;

  return (
    <Rows>
      <Row noPadding paddingBottom={spacingV2.small}>
        <Cols style={{ justifyContent: 'flex-start', alignItems: 'flex-start' }}>
          <Col
            style={{
              marginRight: spacingV2.extraSmall,
            }}
          >
            <TextButton
              size='large'
              color={publicaColors.black}
              onClick={() => {
                setIsExpanded(!isExpanded);
                if (isExpanded) {
                  setIsExpandAll(false);
                }
                if (!isExpanded) {
                  setIsCollapseAll(false);
                }
              }}
            >
              {isExpanded ? '-' : '+'}
            </TextButton>
          </Col>

          <Col>
            <Cols
              onClick={() => {
                if (!isDisabled) {
                  setIsSelected(!isSelected);
                  onSectionChange(
                    list.map((item) => item.ID),
                    !isAllSelected,
                  );
                }
              }}
              style={{ alignItems: 'flex-start', cursor: isDisabled ? 'default' : 'pointer' }}
            >
              <Col>
                <Checkbox
                  size='small'
                  checked={isAllSelected}
                  disabled={isDisabled}
                  indeterminate={0 < numberOfSelectedMetrics && numberOfSelectedMetrics < length}
                  style={{
                    width: '10px',
                    marginLeft: '4px',
                    marginRight: '8px',
                    padding: '0',
                  }}
                />
              </Col>
              <Col
                noVerticalPaddingV2
                extraSmallHorizontalPaddingV2
                style={{
                  backgroundColor: isExpanded ? publicaColors.veryLightGray : '',
                  borderRadius: borderRadius.base,
                }}
              >
                <Text small bold>
                  {`${title} (${numberOfSelectedMetrics}/${length})`}
                </Text>
              </Col>
            </Cols>
          </Col>
        </Cols>
      </Row>

      <Row noVerticalPadding horizontalPadding>
        {isExpanded && <Checkboxes list={list} onChange={onChange} />}
      </Row>
    </Rows>
  );
};
